export default __webpack_public_path__ + "static/media/power-supply-icon.44f5b0d2.svg";